import moment from 'moment';

export const formatDate = (date) => date ? formatDateForInput(date) : date;

export const formatDateForInput = (date) => moment(String(date), 'YYYY-MM-DD').format('DD/MM/YYYY');

export const ucFirst = (string) => string[0].toUpperCase() + string.slice(1);
